// extracted by mini-css-extract-plugin
export default {"column":"ArticleColumn-module--column--3KHkq"};